export const LAST_CHANGED_LABELS = {
  since: 'since',
} as const
